<template>
  <div>
    <a-table
      :columns="getHeaders()"
      :table-data="users"
      :variant="setTableVariant()"
      :filter-columns="['userName', 'name', 'email']"
      :search-value="search"
      :search-field-label="$t('Security.UserAdministration.User')"
      @search="search = $event"
    />
    <reset-password-dialog
      v-model="showResetPasswordDialog"
      :user="selectedUser"
      :password-policies="passwordPolicies"
    />
    <reset-password-email-dialog
      v-model="showResetPasswordEmailDialog"
      :user="selectedUser"
    />
    <reset-password-generate-letter-dialog
      v-model="showGenerateLetterDialog"
      :user="selectedUser"
    />
  </div>
</template>

<script>
import ResetPasswordDialog from "./components/reset-passwort-dialog";
import ResetPasswordEmailDialog from "./components/reset-passwort-email-dialog";
import GenerateLetterDialog from "./components/generate-letter-dialog";
import Users from "./graphql/UsersQuery.gql";
import PasswordPoliciesQuery from "./graphql/PasswordPoliciesQuery.gql";
import { hasManagementRole } from "@/config/keycloak/keycloakUser.js";
import { redirectIfNoAccess } from "@/config/router.js";
import ATable from "+/components/table/Table";
import { TableVariant } from "+/components/table/utils/tableTypes";
import SettingsQuery from "./graphql/SettingsQuery.gql";
import apolloProvider from "@/apollo/provider.js";

export default {
  beforeRouteEnter(to, from, next) {
    apolloProvider.clients.config
      .query({
        query: SettingsQuery
      })
      .then(
        ({ data: { getSettings: { keycloakEnableUserAdministration } } }) => {
          redirectIfNoAccess(
            hasManagementRole("manage-users") && keycloakEnableUserAdministration,
            next
          );
        }
      );
  },
  components: {
    "reset-password-dialog": ResetPasswordDialog,
    "reset-password-email-dialog": ResetPasswordEmailDialog,
    "reset-password-generate-letter-dialog": GenerateLetterDialog,
    "a-table": ATable
  },
  data: () => ({
    users: [],
    search: "",
    passwordPolicies: [],
    showResetPasswordEmailDialog: false,
    showResetPasswordDialog: false,
    showGenerateLetterDialog: false,
    selectedUser: null
  }),
  created() {
    this.prefillSearch();
  },
  methods: {
    setTableVariant() {
      return TableVariant.OVERVIEW;
    },
    getHeaders() {
      return [
        {
          title: this.$t("Security.UserAdministration.UserName"),
          field: "userName",
          sorter: "string"
        },
        {
          title: this.$t("Security.UserAdministration.User"),
          field: "name",
          sorter: "string"
        },
        {
          title: this.$t("Security.UserAdministration.Email"),
          field: "email",
          sorter: "string"
        },
        { type: "action-col" }
      ];
    },
    isNotPersisEmployee(user) {
      return user && user.userType !== "Persis-Employee";
    },
    wrongLoginProcessTooltip() {
      return this.$t(
        "Security.UserAdministration.PasswordResetWrongLoginProcess"
      );
    },
    mapUsers(users) {
      return users.map((user) => {
        const isNotPersisEmployee = this.isNotPersisEmployee(user);
        const actions = [];
        actions.push({
          label: this.$t("Security.UserAdministration.PasswordResetSendEmail"),
          visible: Boolean(user.email),
          disabled: isNotPersisEmployee || !user.email,
          tooltip:
            isNotPersisEmployee || !user.email
              ? this.wrongLoginProcessTooltip()
              : "",
          value: user.id,
          events: {
            click: () => {
              this.selectedUser = user;
              this.showResetPasswordEmailDialog = true;
            }
          }
        });

        actions.push({
          label: this.$t("Security.UserAdministration.PasswordHardReset"),
          visible: !user.email,
          disabled: isNotPersisEmployee,
          tooltip: isNotPersisEmployee ? this.wrongLoginProcessTooltip() : "",
          value: user.id,
          events: {
            click: () => {
              this.selectedUser = user;
              this.showResetPasswordDialog = true;
            }
          }
        });
        actions.push({
          label: this.$t("Security.UserAdministration.PasswordResetSendLetter"),
          visible: !user.email,
          disabled: isNotPersisEmployee,
          tooltip: isNotPersisEmployee ? this.wrongLoginProcessTooltip() : "",
          value: user.id,
          events: {
            click: () => {
              this.selectedUser = user;
              this.showGenerateLetterDialog = true;
            }
          }
        });

        return {
          id: user.id,
          name: `${user.lastName}, ${user.firstName}`,
          email: user.email,
          userName: user.userName,
          actions: actions
        };
      });
    },
    sortUsers(users) {
      return users.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (b.name > a.name) return -1;
        return 0;
      });
    },
    prefillSearch() {
      if (!this.$route.params.personnelNumber) return;

      const personnelNumber = atob(
        this.$route.params.personnelNumber
      ).toLowerCase();
      this.search = personnelNumber;
    }
  },
  apollo: {
    $client: "security",
    users: {
      query: Users,
      variables() {
        return {
          search: this.search
        };
      },
      update({ users }) {
        if (!users || !users.length) return [];
        const requestedUsers = this.mapUsers(users);
        return this.sortUsers(requestedUsers);
      }
    },
    passwordPolicies: {
      query: PasswordPoliciesQuery
    }
  }
};
</script>
